import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCalender5"><Path d="M16 3H8V4.5C8 4.77614 7.77614 5 7.5 5C7.22386 5 7 4.77614 7 4.5V3H5.5C4.11929 3 3 4.11929 3 5.5V7H21V5.5C21 4.11929 19.8807 3 18.5 3H17V4.5C17 4.77614 16.7761 5 16.5 5C16.2239 5 16 4.77614 16 4.5V3Z" fill="currentColor"/><Path d="M21 8H3V18.5C3 19.8807 4.11929 21 5.5 21H18.5C19.8807 21 21 19.8807 21 18.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalender5;
